/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * tabSelecter.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * ページURL取得
 */
var getPathName = location.pathname;
var pageName = /(greenspark109)/g;

/**
 * フロア選択
 */
const setFloorPlan = () => {
    if (getPathName.match(pageName)) {
        const floorTrrigers = document.querySelectorAll(".floor__bg");
        const floorTargets = document.querySelectorAll(".floor__spec");

        for (let i = 0; i < floorTrrigers.length; i++) {
            floorTrrigers[i].addEventListener("mouseenter", (e) => {
                let currentFloor = e.currentTarget;
                let dataId = currentFloor.dataset.id;
                let currentId = document.querySelectorAll(`[data-floor*="${dataId}"]`);

                /**
                 * Floor Plan 選択挙動
                 */
                for (let i = 0; i < floorTrrigers.length; i++) {
                    floorTrrigers[i].classList.remove("is-active");
                }
                currentFloor.classList.add("is-active");

                /**
                 * data-floor属性 class削除
                 */
                for (let i = 0; i < floorTargets.length; i++) {
                    floorTargets[i].classList.remove("is-active");
                }

                /**
                 * data-floor属性 class付与
                 */
                if (currentId !== null) {
                    for (let i = 0; i < currentId.length; i++) {
                        currentId[i].classList.add("is-active");
                    }
                }
            });
            
            floorTrrigers[i].addEventListener("mouseleave", (e) => {
                for (let i = 0; i < floorTrrigers.length; i++) {
                    floorTrrigers[i].classList.remove("is-active");
                }
                for (let i = 0; i < floorTargets.length; i++) {
                    floorTargets[i].classList.remove("is-active");
                }
            })
        }
    }
};

export { setFloorPlan };